// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/models/api/v1/pagination.proto" (package "c1.models.api.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.models.api.v1.PaginationToken
 */
export interface PaginationToken {
    /**
     * @generated from protobuf field: string pk = 1;
     */
    pk: string;
    /**
     * @generated from protobuf field: string sk = 2;
     */
    sk: string;
    /**
     * @generated from protobuf field: string gsi1pk = 3 [json_name = "gsi1pk"];
     */
    gsi1Pk: string;
    /**
     * @generated from protobuf field: string gsi1sk = 4 [json_name = "gsi1sk"];
     */
    gsi1Sk: string;
    /**
     * @generated from protobuf field: uint32 shard = 5;
     */
    shard: number;
}
/**
 * @generated from protobuf message c1.models.api.v1.SearchPaginationToken
 */
export interface SearchPaginationToken {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: number;
}
/**
 * https://cloud.google.com/apis/design/design_patterns#list_pagination
 *
 * @generated from protobuf message c1.models.api.v1.PaginationRequest
 */
export interface PaginationRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * intenral option to ignore page_size and page_token: fetch all objects, and returns
     * PaginationResponse with next_page_token empty.
     *
     * @generated from protobuf field: bool unroll_all = 3;
     */
    unrollAll: boolean;
    /**
     * @generated from protobuf field: bool override_max_page_size = 4;
     */
    overrideMaxPageSize: boolean;
}
/**
 * @generated from protobuf message c1.models.api.v1.PaginationResponse
 */
export interface PaginationResponse {
    /**
     * @generated from protobuf field: string next_page_token = 1;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.models.api.v1.ScanShardedOrderedPageToken
 */
export interface ScanShardedOrderedPageToken {
    /**
     * @generated from protobuf field: uint32 current_shard = 1;
     */
    currentShard: number;
    /**
     * @generated from protobuf field: repeated c1.models.api.v1.ShardPagingKey paging_keys = 2;
     */
    pagingKeys: ShardPagingKey[];
    /**
     * @generated from protobuf field: string high_water_mark_sort_key = 3;
     */
    highWaterMarkSortKey: string;
    /**
     * @deprecated
     * @generated from protobuf field: string partition_key_without_shard = 4 [deprecated = true];
     */
    partitionKeyWithoutShard: string;
}
/**
 * @generated from protobuf message c1.models.api.v1.ShardPagingKey
 */
export interface ShardPagingKey {
    /**
     * @generated from protobuf field: uint32 shard_num = 1;
     */
    shardNum: number;
    /**
     * @generated from protobuf field: string last_seen_sort_key = 2;
     */
    lastSeenSortKey: string;
    /**
     * @generated from protobuf field: bool updated = 3;
     */
    updated: boolean;
    /**
     * @generated from protobuf field: bool exhausted = 4;
     */
    exhausted: boolean;
    /**
     * @generated from protobuf field: uint32 page_size = 5;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: uint32 search_limit = 6;
     */
    searchLimit: number;
}
/**
 * @generated from protobuf enum c1.models.api.v1.SortDirection
 */
export enum SortDirection {
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_ASC = 1;
     */
    ASC = 1,
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_DESC = 2;
     */
    DESC = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class PaginationToken$Type extends MessageType<PaginationToken> {
    constructor() {
        super("c1.models.api.v1.PaginationToken", [
            { no: 1, name: "pk", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sk", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "gsi1pk", kind: "scalar", jsonName: "gsi1pk", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "gsi1sk", kind: "scalar", jsonName: "gsi1sk", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "shard", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.PaginationToken
 */
export const PaginationToken = new PaginationToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPaginationToken$Type extends MessageType<SearchPaginationToken> {
    constructor() {
        super("c1.models.api.v1.SearchPaginationToken", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.SearchPaginationToken
 */
export const SearchPaginationToken = new SearchPaginationToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaginationRequest$Type extends MessageType<PaginationRequest> {
    constructor() {
        super("c1.models.api.v1.PaginationRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "unroll_all", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "override_max_page_size", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.PaginationRequest
 */
export const PaginationRequest = new PaginationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaginationResponse$Type extends MessageType<PaginationResponse> {
    constructor() {
        super("c1.models.api.v1.PaginationResponse", [
            { no: 1, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.PaginationResponse
 */
export const PaginationResponse = new PaginationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ScanShardedOrderedPageToken$Type extends MessageType<ScanShardedOrderedPageToken> {
    constructor() {
        super("c1.models.api.v1.ScanShardedOrderedPageToken", [
            { no: 1, name: "current_shard", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "paging_keys", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ShardPagingKey },
            { no: 3, name: "high_water_mark_sort_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "partition_key_without_shard", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.ScanShardedOrderedPageToken
 */
export const ScanShardedOrderedPageToken = new ScanShardedOrderedPageToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShardPagingKey$Type extends MessageType<ShardPagingKey> {
    constructor() {
        super("c1.models.api.v1.ShardPagingKey", [
            { no: 1, name: "shard_num", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "last_seen_sort_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "updated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "exhausted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 6, name: "search_limit", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ], { "pgdb.v1.msg": { disabled: true } });
    }
}
/**
 * @generated MessageType for protobuf message c1.models.api.v1.ShardPagingKey
 */
export const ShardPagingKey = new ShardPagingKey$Type();
